import React from "react";
import Shop, { ShopData } from "./Shop";

const Shops: React.FC<{
  shops: ShopData[];
}> = ({ shops }) => {

  return shops.length > 0 ? (
    <div className="shops">
      {shops.map((shop) => (
        <Shop
          key={shop.id}
          shop={shop}
        />
      ))}
    </div>
  ) : null;
};

export default Shops;
